import { NgIf } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconComponent } from '@recruitee/user-interface';

import { WysiwygInlineButtonComponent } from './wysiwyg-inline-button.component';

@NgModule({
  imports: [IconComponent, NgIf],
  declarations: [WysiwygInlineButtonComponent],
  exports: [WysiwygInlineButtonComponent],
})
export class WysiwygInlineButtonModule {}
